export enum ROUTE {
    FAQ = '/chathost/faq.html',
    IDEAS = '/chathost/faq.html?qId=81',
    CONTACT_US = '/chathost/contactus.html',
    SIDEBAR = '/chathost/sidebar.html',
    VIEWER_RATINGS = '/chathost/viewerratings.html',
    RULES = '/chathost/rules.html',
    LOGON = '/chathost/logon.html',
    LOGOFF = '/logoff.html?ut=2',
    ADULT_RATINGS = '/chathost/adultratings.html',
    PRIVACY_POLICY = '/chathost/policy.html',
    TERMS_AND_CONDITIONS = '/chathost/terms.html',
    EVENTS = '/chathost/events.html',
    VIDEO_HELP = '/chathost/videohelp.html',
    MAIL_FAQ = '/chathost/mailfaq.html',
    MAIL_OVERVIEW = '/chathost/mailoverview.html',
    MAIL_CONTROL = '/chathost/mailcontrol.html',
    MAIL_LIST = '/chathost/maillist.html',
    MAIL_COMPOSE = '/chathost/viewershistory.html?compose=1',
    MAIL_OPTIONS = '/chathost/mailoptions.html',
    MAIL_BLACKLIST = '/chathost/maildeny.html',
    HOMEPAGE = '/chathost/',
    CHATHOST_RESOURCES = '/chathost/index.html',
    NOT_FOUND = '/chathost/404.html',
    WIZARD_REG = '/chathost/wizardreg.html',
    REGISTRATION = '/make-money/become-chathost.html',
    AGE_VERIFICATION = '/chathost/ageverificationexternal.html',
    PROMOTION_AGREEMENT = '/chathost/cpreq.html',
    MY_AGREEMENTS = '/chathost/myagreements.html',
    CONSENT = '/chathost/consent.html',
    CONSENT_AGREEMENT = '/chathost/consentagreement.html',
    AGREEMENT_DOWNLOAD = '/chathost/agreementdownload.html',
    LUCKY_CHATS = '/chathost/luckychats.html',
    SPOOKY_CHATS = '/chathost/luckychats.html',
    ANNIVERSARY = '/chathost/anniversary.html',
    VALENTINES = '/chathost/valentinesmatch.html',
    ACCOUNT = '/chathost/account.html',
    REVENUE_DETAILS = '/chathost/revenuedetails.html',
    PAYMENT_DETAILS = '/chathost/paymentdetails.html',
    PAYMENT_DETAILS_UPDATE = '/chathost/paymentdetailsupdate.html',
    PAYMENTS_LIST = '/chathost/listpayments.html',
}

export enum ROUTE_STUDIO {
    ACCOUNT_VERIFICATION = '/studio/accountverification.html',
    SIDEBAR = '/studio/sidebar.html',
    FAQ = '/studio/faq.html',
    CONTACT_US = '/studio/contactus.html',
    PRIVACY_POLICY = '/studio/policy.html',
    TERMS_AND_CONDITIONS = '/studio/terms.html',
    LOGON = '/studio/logon.html',
    LOGOFF = '/logoff.html?ut=4',
    VIDEO_HELP = '/studio/videohelp.html',
    ADULT_RATINGS = '/studio/adultratings.html',
    RULES = '/studio/rules.html',
    EVENTS = '/studio/events.html',
    HOMEPAGE = '/studio/',
    MANAGEMENT = '/studio/management.html',
    PAYMENT_DETAILS = '/studio/paymentdetails.html',
    PAYMENT_DETAILS_UPDATE = '/studio/paymentdetailsupdate.html',
    PASSWORD_ADMIN = '/studio/studiochangepasswords.html?actionType=3',
    PASSWORD_OWNER = '/studio/studiochangepasswords.html?actionType=2',
    ACCOUNT = '/studio/account.html',
    REVENUE_DETAILS = '/studio/revenuedetails.html',
    PAYMENTS_LIST = '/studio/listpayments.html',
}

export enum ROUTE_SUFFIX {
    FAQ = 'faq.html',
    VIDEO_HELP = 'videohelp.html',
    CONTACT_US = 'contactus.html',
    ADULT_RATINGS = 'adultratings.html',
    EVENTS = 'events.html',
    RULES = 'rules.html',
    SIDEBAR = 'sidebar.html',
    LOGON = 'logon.html',
}

export const ROUTE_PROMO: string[] = [ROUTE.LUCKY_CHATS, ROUTE.ANNIVERSARY, ROUTE.VALENTINES];

export const ROUTE_GUARDED: string[] = [ROUTE.RULES, ROUTE.VIDEO_HELP, ROUTE.VIEWER_RATINGS, ROUTE.MAIL_FAQ, ROUTE.ADULT_RATINGS, ROUTE.WIZARD_REG, ROUTE.MAIL_OVERVIEW, ROUTE.MAIL_CONTROL, ROUTE.PRIVACY_POLICY, ROUTE.CHATHOST_RESOURCES, ROUTE.HOMEPAGE, ROUTE_STUDIO.RULES, ROUTE_STUDIO.ADULT_RATINGS, ROUTE_STUDIO.VIDEO_HELP, ROUTE_STUDIO.HOMEPAGE, ROUTE.AGE_VERIFICATION, ROUTE.MY_AGREEMENTS, ROUTE.PROMOTION_AGREEMENT, ROUTE.AGREEMENT_DOWNLOAD, ROUTE.CONSENT, ROUTE.CONSENT_AGREEMENT, ROUTE.LUCKY_CHATS, ROUTE.ANNIVERSARY, ROUTE.VALENTINES, ROUTE_STUDIO.ACCOUNT_VERIFICATION, ROUTE_STUDIO.PRIVACY_POLICY, ROUTE_STUDIO.ACCOUNT, ROUTE.ACCOUNT, ROUTE.REVENUE_DETAILS, ROUTE.PAYMENTS_LIST, ROUTE_STUDIO.REVENUE_DETAILS, ROUTE_STUDIO.PAYMENTS_LIST];
